import React from 'react'
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  CContainer,
  CHeader,
  CHeaderDivider,
  CHeaderNav,
  CNavLink,
  CNavItem,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {cilPowerStandby } from '@coreui/icons'

import { AppBreadcrumb } from './index'
import { useNavigate } from 'react-router-dom'

const AppHeader = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
      navigate('/auth/login');
      toastMsg();
  }

   //nautification message
   const toastMsg = () => {
    toast.success("Logout Successful", {
    position: "top-center",
    autoClose: 1000,
  });
};

  return (
    <CHeader position="sticky" className="mb-4">
      <CContainer fluid>
       
        <CHeaderNav className="d-none d-md-flex me-auto"> 
          <AppBreadcrumb />
        </CHeaderNav>

        <CHeaderNav>
          <CNavItem>
            <CNavLink onClick={handleLogout}>
              <CIcon icon={cilPowerStandby} size="lg" /> <span>Logout</span>
            </CNavLink> 
          </CNavItem> 
        </CHeaderNav>
       
      </CContainer>
      <CHeaderDivider />
    </CHeader>
  )
}

export default AppHeader
